var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.isShowTips)?_c('p',[_vm._v("\n      每个文件下载后，将为您保存72小时，点击\n      "),_c('span',{staticClass:"donwload-btn"},[_vm._v("下载")]),_vm._v("\n      即可重新下载;视频文件仅提供6小时保存时间，超时需重新付费\n    ")]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }